import React from "react";
import PropTypes from "prop-types";

import RoField from "Form/RoField";
import { OrderObject } from "./../Queries/OrderQuery";
import { salesRepDataLabelClass } from "./../BusRules/salesRep";

const SalesRepFields = ({ order, currentUser, salesRepControl }) => {
  if (!order.uiState.hasSalesRep) return null;

  const labelClass = salesRepDataLabelClass(order.salesRep);

  return (
    <React.Fragment>
      {salesRepControl || (
        <RoField
          value={order.salesRep ? order.salesRep.name : "-"}
          labelText="Sales Rep"
          dataLabelClass={labelClass}
        />
      )}
      {currentUser.itAdmin && (
        <RoField
          value={order.salesRep ? order.salesRep.gpCode : "-"}
          labelText="GP Code"
          dataLabelClass={labelClass}
        />
      )}
    </React.Fragment>
  );
};

SalesRepFields.propTypes = {
  order: OrderObject,
  currentUser: PropTypes.object.isRequired,
  salesRepControl: PropTypes.node
};

export default SalesRepFields;
